export default {
  UPDATE: 'USER/DETAILS/UPDATE'
};
